import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ScrollToTop from 'components/ScrollToTop';
import ErrorBoundary from 'components/ErrorBoundary';
import NotFound from 'pages/NotFound';
import HomeLandingPage from './pages/home-landing-page';
import LawyerDashboard from './pages/lawyer-dashboard';
import LawyerProfileSetup from './pages/lawyer-profile-setup';
import EmailAuthenticationEntry from './pages/email-authentication-entry';
import OTPVerification from './pages/otp-verification';
import LegalConsultationChatbot from './pages/legal-consultation-chatbot';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<HomeLandingPage />} />

          <Route path="/lawyer-dashboard" element={<LawyerDashboard />} />
          <Route
            path="/lawyer-profile-setup"
            element={<LawyerProfileSetup />}
          />
          <Route
            path="/email-authentication-entry"
            element={<EmailAuthenticationEntry />}
          />
          <Route path="/otp-verification" element={<OTPVerification />} />
          <Route
            path="/legal-consultation-chatbot"
            element={<LegalConsultationChatbot />}
          />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
